import { useAuth } from '@hourly/contexts/AuthContext';
import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { pollDownload } from '../requests/download.request';

export const useDownload = (filename: string) => {
  const [url, setUrl] = useState<string | null>(null);
  const { sessionState } = useAuth();

  useRequest<void, void>(
    async (_, options) => {
      if (filename) {
        const downloadUrl = await pollDownload(
          filename,
          sessionState.partnerId!,
          sessionState.userId!,
          { signal: options?.signal }
        );
        setUrl(downloadUrl);
      }
    },
    { requestOnMount: true }
  );

  return { url };
};
